import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../services/api";
import toast, { Toaster } from "react-hot-toast";
import { Home, ChevronLeft, LayoutGrid, X } from 'lucide-react'; // Importados ícones necessários
import "../styles/Dashboard.css";

export default function Categorias() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editandoId, setEditandoId] = useState(null);

  const initialState = {
    nome: "",
    descricao: "",
    ordem: 0,
    ativo: 1
  };

  const [novaCategoria, setNovaCategoria] = useState(initialState);

  const carregarCategorias = async () => {
    try {
      const { data } = await api.get(`/cardapio/categorias/${id}`);
      setCategorias(data);
    } catch (error) {
      toast.error("Erro ao carregar categorias");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) carregarCategorias();
  }, [id]);

  const abrirEdicao = (cat) => {
    setEditandoId(cat.id);
    setNovaCategoria({
      nome: cat.nome || "",
      descricao: cat.descricao || "",
      ordem: cat.ordem || 0,
      ativo: cat.ativo
    });
    setShowModal(true);
  };

  const fecharModal = () => {
    setShowModal(false);
    setEditandoId(null);
    setNovaCategoria(initialState);
  };

  const salvarCategoria = async (e) => {
    e.preventDefault();
    try {
      const dados = { ...novaCategoria, estabelecimento_id: id };

      if (editandoId) {
        await api.put(`/cardapio/categorias/${editandoId}`, dados);
        toast.success("Categoria atualizada");
      } else {
        await api.post(`/cardapio/categorias`, dados);
        toast.success("Categoria criada");
      }

      fecharModal();
      carregarCategorias();
    } catch (error) {
      toast.error("Erro ao salvar categoria");
    }
  };

  const excluirCategoria = async (categoriaId) => {
    if (!window.confirm("Excluir categoria?")) return;
    try {
      await api.delete(`/cardapio/categorias/${categoriaId}`);
      toast.success("Categoria removida");
      carregarCategorias();
    } catch (error) {
      toast.error("Erro ao excluir");
    }
  };

  const toggleStatus = async (cat) => {
    try {
      await api.put(`/cardapio/categorias/${cat.id}`, {
        ...cat,
        ativo: cat.ativo ? 0 : 1
      });
      toast.success("Status atualizado");
      carregarCategorias();
    } catch (error) {
      toast.error("Erro ao atualizar status");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNovaCategoria(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="dashboard-page">
      <Toaster position="top-right" />

      <header className="dashboard-header">
        <div className="header-left-group" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {/* Botão Home */}
          <button onClick={() => navigate('/dashboard')} className="btn-icon-home" title="Ir para Home">
            <Home size={20} />
          </button>
          
          <div className="divider-vertical"></div>
          
          {/* Botão Voltar para Produtos */}
          <Link to={`/produtos/${id}`} className="btn-sair" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }}>
            <ChevronLeft size={18} /> Voltar
          </Link>
        </div>

        <h2 className="dashboard-logo">Gestão de <b>Categorias</b></h2>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => setShowModal(true)} className="btn-confirm" style={{ background: '#ea1d2c' }}>
            + Nova Categoria
          </button>
        </div>
      </header>

      <main className="dashboard-container">
        <div className="top-info" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '20px' }}>
          <div>
            <h1 style={{ margin: 0, fontSize: "28px", fontWeight: '800' }}>Categorias</h1>
            <p style={{ color: "#64748b" }}>Organize seu cardápio em seções (Ex: Pizzas, Bebidas, Sobremesas).</p>
          </div>
        </div>

        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
            <thead style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
              <tr>
                <th style={{ padding: "15px" }}>Nome</th>
                <th style={{ padding: "15px" }}>Ordem</th>
                <th style={{ padding: "15px" }}>Status</th>
                <th style={{ padding: "15px", textAlign: "right" }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {!loading && categorias.map((cat) => (
                <tr key={cat.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "15px" }}>
                    <strong style={{ display: 'block', color: '#1e293b' }}>{cat.nome}</strong>
                    <small style={{ color: '#64748b' }}>{cat.descricao || "Sem descrição"}</small>
                  </td>
                  <td style={{ padding: "15px" }}>{cat.ordem}º</td>
                  <td style={{ padding: "15px" }}>
                    <span style={{
                      padding: "4px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "700",
                      background: cat.ativo ? "#dcfce7" : "#fee2e2",
                      color: cat.ativo ? "#166534" : "#991b1b"
                    }}>
                      {cat.ativo ? "ATIVO" : "INATIVO"}
                    </span>
                  </td>
                  <td style={{ padding: "15px", textAlign: "right" }}>
                    <button onClick={() => abrirEdicao(cat)} className="btn-text" style={{ marginRight: '10px' }}>Editar</button>
                    <button onClick={() => toggleStatus(cat)} className="btn-text" style={{ color: '#64748b', marginRight: '10px' }}>
                      {cat.ativo ? "Pausar" : "Ativar"}
                    </button>
                    <button onClick={() => excluirCategoria(cat.id)} className="btn-delete-text">Excluir</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {!loading && categorias.length === 0 && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
              Nenhuma categoria cadastrada ainda.
            </div>
          )}
        </div>
      </main>

      {showModal && (
        <div className="modal-overlay" style={{ zIndex: 9999 }}>
          <div className="modal">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0 }}>{editandoId ? "Editar Categoria" : "Nova Categoria"}</h2>
              <button onClick={fecharModal} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b' }}>
                <X size={24} />
              </button>
            </div>
            
            <form onSubmit={salvarCategoria}>
              <label className="label">Nome da Categoria</label>
              <input
                className="input"
                name="nome"
                type="text"
                autoComplete="off"
                placeholder="Ex: Pizzas Salgadas"
                value={novaCategoria.nome}
                onChange={handleChange}
                required
              />

              <label className="label">Descrição (Opcional)</label>
              <textarea
                className="input"
                name="descricao"
                placeholder="Ex: Todas as nossas pizzas acompanham borda simples."
                style={{ height: "70px" }}
                value={novaCategoria.descricao}
                onChange={handleChange}
              />

              <div className="row">
                <div className="col">
                  <label className="label">Ordem de Exibição</label>
                  <input
                    type="number"
                    name="ordem"
                    className="input"
                    value={novaCategoria.ordem}
                    onChange={handleChange}
                  />
                </div>
                <div className="col">
                  <label className="label">Status</label>
                  <select
                    className="input"
                    name="ativo"
                    value={novaCategoria.ativo}
                    onChange={(e) => setNovoCategoria(prev => ({ ...prev, ativo: Number(e.target.value) }))}
                  >
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                  </select>
                </div>
              </div>

              <div className="modal-buttons" style={{ marginTop: '20px' }}>
                <button type="button" onClick={fecharModal} className="btn-text">Cancelar</button>
                <button type="submit" className="btn-confirm">
                  {editandoId ? "Atualizar" : "Salvar Categoria"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}